<template>
    <grid
        :column-defs="columnDefs"
        :row-data="globalVariables"
    >
        <responsive-button
            :icon="['fas', 'plus']"
            @click="showAddVariableModalForm"
            variant="primary"
        >Add Variable</responsive-button>
        <variables-detail-modal-form 
            :modal-id="addGlobalVariableModalID"
            :create="addGlobalVariable"
            :key="addGlobalVariableModalKey"
            :initial-values="nextVariableName"
            :variable-type="'Global Variable'"
            @success-save="load"
        ></variables-detail-modal-form>
        <variables-detail-modal-form 
            :modal-id="updateGlobalVariableModalID"
            :update="updateGlobalVariable"
            :key="updateGlobalVariableModalKey"
            :variable-type="'Global Variable'"
            :initial-values="currentGlobalVariable"
            @success-save="load"
        ></variables-detail-modal-form>
    </grid>
</template>
<script>
    import API from '../../api';
    import { formatResponseError } from '../../utils/api';
    import ActionsCellRenderer from './common/actions-cell-renderer.vue';
    import BusyModal from '../generic/busy-modal/busy-modal.vue';
    import Grid from '../generic/grid/grid.vue';
    import ResponsiveButton from '../generic/responsive-button/responsive-button.vue';
    import VariablesDetailModalForm from './common/variables-detail-modal-form.vue';
    import {
        CUSTOM_VARIABLES_GLOBAL_VARIABLES_LIST_ENDPOINT,
        CUSTOM_VARIABLES_GLOBAL_VARIABLE_BY_ID_ENDPOINT,
    } from '../../endpoints';


    export default {
        name: 'CustomGlobalVariables',
        components: {
            Grid,
            ResponsiveButton,
            VariablesDetailModalForm,
            BusyModal,
            actionsCellRenderer: ActionsCellRenderer,
        },
        mounted() {
            this.load();
        },
        computed: {
            nextVariableName() {
                const variableNamePattern = new RegExp('^CUSTOM_VARIABLE_(\\d+)$');
                var index = 0;
                this.globalVariables.forEach(item => {
                    var match = item.name.match(variableNamePattern);
                    if (match) {
                        var n = parseInt(match[1]);
                        if (n > index) {
                            index = n;
                        }
                    }
                });
                return { name: 'CUSTOM_VARIABLE_' + ++index }
            },
        },
        data() {
            return {
                updateGlobalVariableModalKey: 0,
                addGlobalVariableModalKey: 1,
                addGlobalVariableModalID: 'add-global-variable-modal-id',
                updateGlobalVariableModalID: 'update-global-variable-modal-id',
                currentGlobalVariable: {},
                globalVariables: [],
                columnDefs: [
                    {
                        field: 'order',
                        headerName: 'Order',
                        maxWidth: 110,
                    },
                    {
                        field: 'name',
                        headerName: 'Name',
                    },
                    {
                        field: 'description',
                        headerName: 'Description',
                    },
                    {
                        field: 'value',
                        headerName: 'Value',
                    },
                    {
                        field: 'length',
                        headerName: 'Length',
                    },
                    {
                        headerName: '',
                        maxWidth: 130,
                        minWidth: 130,
                        resizable: false,
                        sortable: false,
                        cellStyle: { textAlign: 'center' },
                        cellRenderer: 'actionsCellRenderer',
                        cellRendererParams: {
                            update: (data) => {
                                this.currentGlobalVariable = data;
                                this.updateGlobalVariableModalKey += 2;
                                this.$nextTick(() => {
                                    this.$bvModal.show(this.updateGlobalVariableModalID);
                                });
                            },
                            delete: async (data, values) => {
                                this.$parent.$emit('busy', true);

                                try {
                                    await API.delete(
                                        CUSTOM_VARIABLES_GLOBAL_VARIABLE_BY_ID_ENDPOINT(data.id),
                                        { data: values }
                                    );
                                    await this.fetchGlobalVariables();
                                } catch (err) {
                                    const { generic } = formatResponseError(err);
                                    this.errorToast({text: generic || 'Could not delete variable.'});
                                } finally {
                                    this.$parent.$emit('busy', false);
                                }
                            },
                        }
                    },
                ],
            }
        },
        methods: {
            async fetchGlobalVariables() {
                try {                    
                    const response = await API.get(CUSTOM_VARIABLES_GLOBAL_VARIABLES_LIST_ENDPOINT());
                    this.globalVariables = response.data;
                } catch (err) {
                    const { generic } = formatResponseError(err);
                    this.errorToast({text: generic || 'Could not fetch variables.'});
                }
            },
            async load() {
                this.$parent.$emit('busy', true);

                try {
                    await this.fetchGlobalVariables();
                } finally {
                    this.$parent.$emit('busy', false);
                }
            },
            showAddVariableModalForm() {
                this.addGlobalVariableModalKey += 2;
                this.$nextTick(() => {
                    this.$bvModal.show(this.addGlobalVariableModalID);
                });
            },
            addGlobalVariable(data) {
                return API.post(CUSTOM_VARIABLES_GLOBAL_VARIABLES_LIST_ENDPOINT(), data);
            },
            updateGlobalVariable({ id, ...payload }) {
                return API.put(CUSTOM_VARIABLES_GLOBAL_VARIABLE_BY_ID_ENDPOINT(id), payload);
            }
        }

    }
</script>
